import { CdkStep } from "@angular/cdk/stepper";
import {
	AfterViewInit,
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output,
	ViewChild,
	ViewEncapsulation,
} from "@angular/core";
import { MatStepper } from "@angular/material/stepper";

import { FlowStep, FlowStepConfig } from "../flow.model";

@Component({
	selector: "obg-sequential-flow-stepper",
	templateUrl: "sequential-flow-stepper.component.html",
	styleUrls: ["sequential-flow-stepper.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SequentialFlowStepperComponent implements AfterViewInit {
	@HostBinding("class.obg-flow") hostCssClass = true;

	@ViewChild(MatStepper) flowStepper!: MatStepper;

	@Input() flowSteps!: FlowStep[];
	@Input() linear = true;
	@Input() loading = false;
	@Input() flowStartIndex = 0;
	@Input() stepperContainer: HTMLElement | undefined;
	@Input() extraHeightForResizeAnimation = 0;
	@Input() showPlaceholderStep = false;
	@Input() placeholderStepLabel = "Open Account";
	@Input() stepsComponentConfiguration: FlowStepConfig[] | undefined;
	@Input() hideStepperHeader = false;

	@Output() viewInitDone = new EventEmitter();
	@Output() activeStepChange = new EventEmitter<FlowStep>();
	@Output() heightChangeAnimationDone = new EventEmitter();
	@Output() heightChangeAnimationStart = new EventEmitter();

	get stepperIndex(): number {
		return this.showPlaceholderStep ? -1 : 0;
	}

	get startIndex(): number {
		if (this.flowStartIndex) {
			return this.flowStartIndex;
		}
		return this.showPlaceholderStep ? 1 : 0;
	}

	ngAfterViewInit() {
		this.flowStepper.steps.forEach((step, index) => {
			const isCompleted = !!(index <= this.startIndex);
			this.changeStepStatus(step, isCompleted);
		});
		this.viewInitDone.emit();
		this.activeStepChange.emit(this.flowSteps[this.flowStepper.selectedIndex + this.stepperIndex]);
	}

	goToNextStep() {
		const nextStep = this.flowStepper.steps.get(this.flowStepper.selectedIndex + 1);
		this.changeStepStatus(this.flowStepper.selected, true);
		this.changeStepStatus(nextStep, false, true);
		this.flowStepper.next();
		this.activeStepChange.emit(this.flowSteps[this.flowStepper.selectedIndex + this.stepperIndex]);
	}

	goToSelectedStep(stepIndex: number) {
		this.flowStartIndex = stepIndex;
		this.flowStepper.selectedIndex = stepIndex;
		this.activeStepChange.emit(this.flowSteps[stepIndex + this.stepperIndex]);
	}

	private changeStepStatus(step: CdkStep | undefined, isCompleted: boolean, isEditable = false) {
		if (step) {
			step.completed = isCompleted;
			step.editable = isEditable;
		}
	}
}
